'use strict';

exports.__esModule = true;

var _apiClient = require('../../network/api-client');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  BASE: '/courier/password'
};

exports.default = { change: change

  /**
   * Update courier's password
   * @returns {Object|null} error object or `null` in case of success
   */
};
function change(currentPassword, password) {
  return _apiClient2.default.put({
    route: API.BASE,
    data: {
      currentPassword: currentPassword,
      password: password
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/courier/password/password.js
// module id = 1186
// module chunks = 0